<script setup>
import { ref } from 'vue';
import BaseBubble from './Base.vue';
import FormattedContent from './Text/FormattedContent.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { content } = useMessageContext();
const collapsed = ref(true);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="transcript">
    <div class="gap-3 flex flex-col">
      <FormattedContent v-if="!collapsed" :content="content" />
      <button
        class="text-n-slate-11 px-1 leading-none text-sm bg-n-alpha-black2 text-center flex items-center gap-1 mt-1 mb-1"
        @click="collapsed = !collapsed"
      >
        {{
          collapsed
            ? $t('CONVERSATION.TRANSCRIPT.SHOW')
            : $t('CONVERSATION.TRANSCRIPT.HIDE')
        }}
        <Icon
          :icon="collapsed ? 'i-lucide-chevron-down' : 'i-lucide-chevron-up'"
          class="size-3"
        />
      </button>
    </div>
  </BaseBubble>
</template>
